import { Host, h } from '@stencil/core';
export class AibaGEnericBlock {
  constructor() {
    this.handleClick = undefined;
    this.data = undefined;
    this._id = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.heading = undefined;
    this.dynamicData = undefined;
  }
  async componentWillRender() {
    var _a;
    this.handlers && this.handlers.genericBlockWillRenderhandler && (await ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.genericBlockWillRenderhandler()));
  }
  async componentDidLoad() {
    var _a;
    this.handlers && this.handlers.genericBlockDidLoadhandler && (await ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.genericBlockDidLoadhandler()));
  }
  async componentWillLoad() {
    var _a;
    this.dynamicData = this.handlers && this.handlers.genericBlockWillLoadhandler && (await ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.genericBlockWillLoadhandler(this.data)));
    if (this.handlers && this.handlers.getGenericBlockData) {
      this.data = await this.handlers.getGenericBlockData();
    }
  }
  async handleClickHandler(event, element) {
    var _a;
    const handlerName = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.handleClick;
    this.handlers && (await (this === null || this === void 0 ? void 0 : this.handlers[handlerName](event, element)));
  }
  render() {
    var _a, _b, _c;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, { id: this._id ? this._id : '' }, this.styles && h("style", null, this.styles), h("div", { class: `generic-block-wrapper`, id: this._id ? this._id : '' }, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) &&
      ((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.elements) === null || _c === void 0 ? void 0 : _c.map(element => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-generic-block') {
          return h("aiba-generic-block", { data: element && element['data'], _id: element['_id'] ? element['_id'] : '', handlers: this === null || this === void 0 ? void 0 : this.handlers });
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label') {
          if (this.dynamicData && this.dynamicData['aiba-label'] && this.dynamicData['aiba-label'][(_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a._id]) {
            if ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.setInnerHTML) {
              return h("aiba-label", Object.assign({}, element.data, { innerHTML: this.dynamicData['aiba-label'][(_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c._id] }));
            }
            else {
              return h("aiba-label", Object.assign({}, element.data, { text: this.dynamicData['aiba-label'][(_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d._id] }));
            }
          }
          else {
            return h("aiba-label", Object.assign({}, element.data));
          }
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-input') {
          return h("aiba-input", Object.assign({}, element.data));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-button') {
          return (h("aiba-button", Object.assign({}, element.data, { handleClick: event => {
              var _a, _b;
              return typeof element.data.handleClick === 'string'
                ? this.handleClickHandler(event, element ? element : '')
                : this.handleClick(event, ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a._id) ? (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b._id : '');
            }, classes: element && element['data'] })));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-image') {
          if (this.dynamicData && this.dynamicData['aiba-image'] && this.dynamicData['aiba-image'][(_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e._id]) {
            return (h("div", { class: "generic-block-image" }, h("img", { src: this.dynamicData['aiba-image'][(_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f._id]['src'], alt: (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.altText })));
          }
          else {
            return (h("div", { class: "generic-block-image" }, h("img", { src: (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.src, alt: (_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.altText })));
          }
        }
        if (element && element['name'] === 'aiba-hero-image') {
          if (this.dynamicData && this.dynamicData['aiba-hero-image'] && this.dynamicData['aiba-hero-image'][(_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k._id]) {
            return h("aiba-hero-image", Object.assign({}, this.dynamicData['aiba-hero-image'][(_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l._id]));
          }
          else {
            return h("aiba-hero-image", Object.assign({}, element['data']));
          }
        }
        if (element && element['name'] === 'aiba-link') {
          return h("aiba-link", Object.assign({ clickEvent: (e) => this.handlers && this.handlers.linkClickHandler(e) }, element['data']));
        }
        if (element && element['name'] === 'aiba-loading-bar') {
          return h("aiba-loading-bar", Object.assign({}, this.data));
        }
        if (element && element['name'] === 'aiba-video') {
          if (this.dynamicData && this.dynamicData['aiba-video'] && this.dynamicData['aiba-video'][(_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m._id]) {
            return h("aiba-video", { data: Object.assign({}, this.dynamicData['aiba-video'][(_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o._id]), handlers: this.handlers });
          }
          else {
            return h("aiba-video", { data: element === null || element === void 0 ? void 0 : element.data, handlers: this.handlers });
          }
        }
        if (element && element['name'] === 'aiba-spinner') {
          {
            return h("aiba-spinner", { text: element['data']['text'], alignment: "horizontal", loaderCircleWidthValue: "5", spinnerCircleColorType: "secondary" });
          }
        }
        if (element.name === 'aiba-progress-bar') {
          if (this.dynamicData && this.dynamicData['aiba-progress-bar'] && this.dynamicData['aiba-progress-bar'][(_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p._id]) {
            return (h("aiba-progress-bar", { progress: ((_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q._id) ? this.dynamicData['aiba-progress-bar'][(_r = element === null || element === void 0 ? void 0 : element.data) === null || _r === void 0 ? void 0 : _r._id] : this.dynamicData['aiba-progress-bar'], status: (element === null || element === void 0 ? void 0 : element.status) || 'low' }));
          }
          else {
            return h("aiba-progress-bar", { progress: (_s = element === null || element === void 0 ? void 0 : element.data) === null || _s === void 0 ? void 0 : _s.value, status: (element === null || element === void 0 ? void 0 : element.status) || 'low' });
          }
        }
        if (element && element['name'] === 'aiba-tabs')
          return h("aiba-tabs", Object.assign({}, element, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-weather-assessment') {
          return h("aiba-weather-assessment", Object.assign({}, element, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        }
      })))));
  }
  static get is() { return "aiba-generic-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-generic-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-generic-block.css"]
    };
  }
  static get properties() {
    return {
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "_id": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "heading": {},
      "dynamicData": {}
    };
  }
}
//# sourceMappingURL=aiba-generic-block.js.map
